/* eslint-disable */
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import WarningIcon from '@material-ui/icons/Warning';
import React from 'react';
import compose from 'recompose/compose';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import BannerPropTypes from './Banner.component.props';
import bannerStyles from './Banner.component.styles';

const isIE = navigator.userAgent.indexOf(`MSIE`) !== -1 || !!document.documentMode === true;

/**
 * Banner
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const BannerComponent = ({ classes }) => {
  return (
    isIE && (
      <AppBar className={classes.bannerAppBar}>
        <Toolbar className={classes.bannerToolbar}>
          <WarningIcon className={classes.bannerIcon} />
          <Typography variant="caption">
            Internet Explorer is not currently supported in Boral Connects. For the best experience, please upgrade your browser to{` `}
            <a className={classes.bannerLink} href="https://www.microsoft.com/en-au/windows/microsoft-edge" rel="noopener noreferrer" target="_blank">
              Microsoft Edge
            </a>
            {` `}or{` `}
            <a className={classes.bannerLink} href="https://www.google.com/chrome/" rel="noopener noreferrer" target="_blank">
              Google Chrome
            </a>
            {` `}
            before continuing.
          </Typography>
        </Toolbar>
        <Divider />
      </AppBar>
    )
  );
};

BannerComponent.propTypes = BannerPropTypes;

const Banner = compose(withStyles(themeCreateInjectableStyles(bannerStyles), { withTheme: true }))(BannerComponent);

export default Banner;
